<div class="d-flex">
  <div class="flex-1"></div>
  <div class="flex-1 flex-no-shrink search-container">
    <app-form-field-text
      (keyup.enter)="reload()"
      [field]="searchControl"

      label="label.user-search"
    ></app-form-field-text>
  </div>
  <div class="d-flex">
    <button (click)="reload()" type="button" class="btn border-0">
      <i class="bi bi-search"></i>
    </button>
  </div>
</div>
